module.exports = __webpack_public_path__ + "static/media/badge-google-play-store.76870254.png";